import * as RadixDialog from '@radix-ui/react-dialog';

import { Close } from '@lichtblick/icons';
import { TextVariants } from '@lichtblick/theme';
import { ButtonVariant } from '@lichtblick/types';

import { Content, ActionsContainer } from './MessageDialog.styles';

import { Button } from '../../Button';
import { IconButton } from '../../IconButton';
import { Text } from '../../Text';
import { Overlay, CloseButton } from '../Dialog.styles';

type MessageDialogProps = {
  acceptLabel?: string;
  cancelLabel?: string;
  children?: React.ReactNode;
  className?: string;
  controlLayout?: 'center' | 'left' | 'right';
  description?: string;
  isActionContainer?: boolean;
  isOpen?: boolean;
  onAccept?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
  shouldAllowAccept?: boolean;
  shouldHaveStickyCloseButton?: boolean;
  title?: string;
  trigger?: React.ReactElement;
  variant?: ButtonVariant;
};

export const MessageDialog = ({
  acceptLabel,
  cancelLabel,
  children,
  className = '',
  controlLayout = 'center',
  description,
  isActionContainer = true,
  isOpen,
  onAccept,
  onCancel,
  onClose,
  shouldAllowAccept = true,
  shouldHaveStickyCloseButton = false,
  title,
  trigger,
  variant,
}: MessageDialogProps) => {
  return (
    <RadixDialog.Root open={isOpen}>
      {trigger && <RadixDialog.Trigger asChild>{trigger}</RadixDialog.Trigger>}
      <RadixDialog.Portal>
        <Overlay>
          <Content className={className}>
            <CloseButton $shouldSticky={shouldHaveStickyCloseButton} asChild className="dialogCloseButton">
              <IconButton icon={<Close />} onClick={() => onClose?.()} variant="ghost" />
            </CloseButton>
            {title && (
              <RadixDialog.Title asChild>
                <Text $variant={TextVariants.header.m}>{title}</Text>
              </RadixDialog.Title>
            )}
            {description && (
              <RadixDialog.Description asChild>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingLeft: '4rem',
                    paddingRight: '4rem',
                  }}
                >
                  <Text $variant={TextVariants.body.m}>{description}</Text>
                </div>
              </RadixDialog.Description>
            )}
            {children}
            {isActionContainer && (
              <ActionsContainer controlLayout={controlLayout}>
                {acceptLabel && (
                  <Button isDisabled={!shouldAllowAccept} label={acceptLabel} onClick={onAccept} variant={variant} />
                )}
                {cancelLabel && (
                  <RadixDialog.Close asChild>
                    <Button label={cancelLabel} onClick={() => onCancel?.()} variant="secondary" />
                  </RadixDialog.Close>
                )}
              </ActionsContainer>
            )}
          </Content>
        </Overlay>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
};
